"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const BaseApi_1 = __importDefault(require("./BaseApi"));
class CartApi extends BaseApi_1.default {
    create(data) {
        return this.http.post("/shop/api/v1/carts/", data);
    }
    update(id, data) {
        return this.http.patch(`/shop/api/v1/carts/${id}/`, data);
    }
    get(id) {
        return this.http.get(`/shop/api/v1/carts/${id}/`);
    }
    clear(id) {
        return this.http.delete(`/shop/api/v1/carts/${id}/items/`);
    }
    clearSignup(id) {
        return this.http.post(`/shop/api/v1/carts/${id}/clear_cart_signup/`);
    }
    replaceProduct(id, productID, quantity = 1, replacementProductID = productID) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "replace",
            product: productID,
            quantity,
            replacement_product: replacementProductID,
        });
    }
    addProduct(id, productID, quantity = 1) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "add",
            product: productID,
            quantity,
        });
    }
    bulkAdd(id, items) {
        const payload = items.map(item => ({
            item_id: item.itemID,
            quantity: item.quantity || 1,
            is_bundle: item.isBundle,
        }));
        return this.http.post(`/shop/api/v1/carts/${id}/bulk_add/`, {
            items: payload,
        });
    }
    removeProduct(id, productID, quantity = 1) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "remove",
            product: productID,
            quantity,
        });
    }
    replaceBundle(id, bundleID, quantity = 1, replaceBundleID = bundleID) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "replace bundle",
            bundle: bundleID,
            quantity,
            replacement_bundle: replaceBundleID,
        });
    }
    addBundle(id, bundleID, quantity = 1) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "add bundle",
            bundle: bundleID,
            quantity,
        });
    }
    removeBundle(id, bundleID, quantity = 1) {
        return this.http.post(`/shop/api/v1/carts/${id}/items/`, {
            action: "remove bundle",
            bundle: bundleID,
            quantity,
        });
    }
    enableFeatureFlag(id, feature) {
        return this.http.post(`/shop/api/v1/carts/${id}/enable_feature_flag/`, {
            feature_flag: feature.name,
        });
    }
    disableFeatureFlag(id, feature) {
        return this.http.post(`/shop/api/v1/carts/${id}/disable_feature_flag/`, {
            feature_flag: feature.name,
        });
    }
    generateOrderNumber(id) {
        return this.http.post(`/shop/api/v1/carts/${id}/generate_order_number/`, {});
    }
    expressEFTPaymentIntent(id) {
        return this.http.post(`/shop/api/v1/carts/${id}/eft_intent/`);
    }
    expressCardOnDeliveryPaymentIntent(id) {
        return this.http.post(`/shop/api/v1/carts/${id}/card_on_delivery_intent/`);
    }
    initiateBlackbirdPayment(id, paymentMethod, tokenize = false, amount) {
        const payload = {
            tokenize,
            payment_method: paymentMethod,
        };
        if (amount) {
            payload.amount = amount;
        }
        return this.http.post(`/shop/api/v1/carts/${id}/initiate_blackbird_payment/`, payload);
    }
    initiateCheckoutPayment(id, amount, success_url, cancel_url) {
        const payload = {};
        if (amount) {
            payload.amount = amount;
        }
        if (success_url) {
            payload.success_url = success_url;
        }
        if (cancel_url) {
            payload.cancel_url = cancel_url;
        }
        return this.http.post(`/shop/api/v1/carts/${id}/initiate_checkout_payment/`, payload);
    }
    initiateFreePayment(id) {
        return this.http.post(`/shop/api/v1/carts/${id}/initiate_free_payment/`, {
            id,
        });
    }
    processBlackbirdPayment(id, paymentId, paymentMethod) {
        return this.http.post(`/shop/api/v1/carts/${id}/process_blackbird_payment/`, { id: paymentId, payment_method: paymentMethod });
    }
    processBlackbirdCreditCardPaymentAndActivateInstalmentPlan(id, paymentId) {
        return this.http.post(`/shop/api/v1/carts/${id}/process_blackbird_credit_card_payment_and_activate_instalment_plan/`, { id: paymentId });
    }
    generateStitchInstantEFTPaymentLink(id, returnUrl) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = (yield this.http.post(`/shop/api/v1/carts/${id}/stitch_instant_eft/`, {
                return_url: returnUrl,
            }));
            return data.payment_link;
        });
    }
    validatePromoCode(id, promo_code) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.http.get(`/shop/api/v1/carts/${id}/validate_promo_code/${promo_code}/`);
        });
    }
}
exports.default = CartApi;
